// removed by extract-text-webpack-plugin
module.exports = {"icon":"pdp-shipping-blurb__icon__165b282f","title":"pdp-shipping-blurb__title__165b282f","info":"pdp-shipping-blurb__info__165b282f","link":"pdp-shipping-blurb__link__165b282f","promo":"pdp-shipping-blurb__promo__165b282f","quote":"pdp-shipping-blurb__quote__165b282f"};


//////////////////
// WEBPACK FOOTER
// ./assets/scss/new-pdp/pdp-shipping-blurb.scss
// module id = 1877
// module chunks = 7 16